import React from 'react';

function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-text">
        <h1 className="animated-gradient-text">Salut, sunt Flavius</h1>
        <p>Un explorator de idei.</p>
        <a href="#about" className="cta-button">Află mai mult</a>
      </div>
    </section>
  );
}

export default Hero;